 import React, { Component } from 'react';
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";
 import config from "../config";
 const _ = require('lodash')

export default class Permissions extends Component {
    static contextType = AuthContext
    constructor(props, context) {
        super(props);
        this.authContext = context;
        this.state = {
            items: null
        }
        this.getStore();
        this.OnChangeRole = this.OnChangeRole.bind(this)
    }
    getStore()  {
        fetcher(`${config.API()}permissions`)
            .then(response => response.json())
            .then(data => {
                if(data.items)
                    this.setState({items: data.items})

            }).catch(function(err) {
            console.error(err);
        });
    }
    OnChangeRole(login)  {
        let that = this;
        return function(event) {
            console.log(event, event.target.value);


            let items = that.state.items
            var obj = _.find(items, x => x.login == login)
            obj.role = event.target.value;
            that.setState({items})

            fetcher(`${config.API()}permissions/set`,{
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    login,
                    role: event.target.value
                })
            })
                .then(response => response.json())
                .then(data => {
                    if(data.items)
                        this.setState({items: data.items})

                }).catch(function(err) {
                    console.error(err);
                });
        }
    }

    render() {
        let list = [];
        if(this.state && this.state.items != null) {
            for(let x of this.state.items){
                list.push(
                    <tr key={x.login}>
                        <td>{x.login}</td>
                        <td>
                            <select onChange={this.OnChangeRole(x.login)}>
                                <option value="guest" selected={x.role == "guest"}>guest</option>
                                <option value="qa" selected={x.role == "qa"}>qa</option>
                                <option value="master" selected={x.role == "master"}>master</option>
                            </select>
                        </td>
                        <td></td>
                    </tr>
                )
            }
        }
        return (
            <div>
                <div className="card shadow w100">
                    <div className="card-header py-3"><h2 className="m-0 font-weight-bold"> Permissions </h2></div>
                    <div className="card-body">
                        <table className="dataTable table table-align-middle table-bordered table-sm" width="100%" cellSpacing="0">
                            <thead>
                            <tr>
                                <th>Login</th>
                                <th>Role</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {list}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

